module.exports = __webpack_public_path__ + "static/media/badge.faea2063.webp";